module.exports = __webpack_public_path__ + "img/icon-sdk.24fc38e4.png";